'use client'

import { z } from 'zod'

const contextSchema = z.object({
  ownerId: z.string().min(1),
  orderId: z.string().min(1),
  path: z.string().min(1).max(2000),
  createdAt: z.number(),
})
const PREFIX = 'veluvit:payment:return:'

export function checkedPaymentReturnPath(path: string) {
  const url = new URL(path, window.location.origin)
  if (
    !path.startsWith('/') ||
    path.startsWith('//') ||
    url.origin !== window.location.origin ||
    url.pathname.startsWith('/payment/')
  )
    throw new Error('결제 후 돌아갈 화면을 확인할 수 없어요.')
  return url.pathname + url.search
}

export function rememberPaymentReturn(ownerId: string, orderId: string) {
  const current = window.location.pathname + window.location.search
  const path = current.startsWith('/payment/')
    ? '/my'
    : checkedPaymentReturnPath(current)
  sessionStorage.setItem(
    PREFIX + orderId,
    JSON.stringify({ ownerId, orderId, path, createdAt: Date.now() })
  )
}

export function readPaymentReturn(orderId: string) {
  let parsed: z.infer<typeof contextSchema>
  try {
    const result = contextSchema.safeParse(
      JSON.parse(sessionStorage.getItem(PREFIX + orderId) ?? 'null')
    )
    if (
      !result.success ||
      result.data.orderId !== orderId ||
      Math.abs(Date.now() - result.data.createdAt) > 86_400_000
    )
      return null
    parsed = result.data
  } catch {
    return null
  }
  try {
    return { ...parsed, path: checkedPaymentReturnPath(parsed.path) }
  } catch {
    return null
  }
}

export function clearPaymentReturn(orderId: string) {
  try {
    sessionStorage.removeItem(PREFIX + orderId)
  } catch {
    /* 복귀 정보는 결제 증빙이 아니다. */
  }
}
